import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getAuthHeaders() {
  const token = localStorage.getItem("percasa_token") || sessionStorage.getItem("percasa_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function api(path, options = {}) {
  return axios({
    url: `${BASE}${path}`,
    headers: { ...getAuthHeaders(), ...(options.headers || {}) },
    ...options,
  });
}

export const apiGet    = (path) => api(path);
export const apiPost   = (path, data) => api(path, { method: "POST", data });
export const apiPut    = (path, data) => api(path, { method: "PUT", data });
export const apiDelete = (path, data) => api(path, { method: "DELETE", data });

export async function viewReceipt(filename) {
  const res = await api(`/receipts/${filename}`, { responseType: "blob" });
  const type = res.headers["content-type"] || "application/octet-stream";
  const url = URL.createObjectURL(new Blob([res.data], { type }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default api;
